<template>
  <v-app-bar
    color="ghostWhite"
    class="criticism-toolbar__content elevation-0 px-0 px-sm-5"
  >
    <v-row>
      <v-col cols="12" md="auto">
        <p class="form__title primary--text my-3 my-sm-0">
          CRÍTICAS
        </p>
      </v-col>
      <v-spacer />
      <v-col cols="12" sm="6" md="4">
        <BaseButton class="secondary" width="100%" @click="newCriticism">
          <v-icon class="pr-3">
            fa-plus
          </v-icon>
          NOVA CRÍTICA OU CHAT
        </BaseButton>
      </v-col>
    </v-row>
  </v-app-bar>
</template>
<script>
export default {
  methods: {
    newCriticism() {
      this.$router.push(this.newRoute);
    }
  },
  props: {
    quotation: {
      type: Object
    },
    newRoute: {
      type: Object,
      default: () => ({
        name: "quotation new criticism"
      })
    }
  }
};
</script>
<style lang="sass">
.criticism-toolbar__
  &content
    z-index: 6
    @media(max-width: 600px)
      height: 150px !important
    height: 80px !important
    align-items: center
    .v-toolbar__content
      @media(max-width: 600px)
        height: 120px !important
      height: 80px !important
</style>
